<section>
	<h3>Credits</h3>
	<ul>
		<li>
			<strong>
				<a href="https://icon-sets.iconify.design/">Iconify</a>
			</strong> <span>- Icon source</span>
		</li>

		<li>
			<strong>
				<a href="https://github.com/SAWARATSUKI/KawaiiLogos">KawaiiLogos</a>
			</strong>
			<span>- Logo Inspiration</span>
		</li>
		<li>
			<strong>
				<a href="https://sonner.emilkowal.ski/">Sonner</a>
			</strong>
			<span>- Website theme Inspiration</span>
		</li>
	</ul>
</section>

<style lang="scss">
ul {
	li {
		margin-left: -1rem;
		margin-block: 0.5rem;
		strong {
			a {
				font-weight: 500;
			}
		}
	}
}
</style>
